/**
 * Jobs UI browser tracing (subscription, jobStats, list patches).
 *
 * Enable in DevTools console, then reload:
 *   localStorage.setItem('CB_JOBS_UI_DEBUG', '1')
 * Filter console by: [CB jobs]
 * Disable:
 *   localStorage.removeItem('CB_JOBS_UI_DEBUG')
 */

export function isJobsUiDebugEnabled() {
  if (typeof window === "undefined" || !window.localStorage) {
    return false
  }
  try {
    const v = window.localStorage.getItem("CB_JOBS_UI_DEBUG")
    if (v === null || v === undefined || String(v).trim() === "") {
      return false
    }
    const s = String(v).trim().toLowerCase()
    return s === "1" || s === "true" || s === "yes" || s === "on"
  } catch (e) {
    return false
  }
}

/**
 * @param {string} section short label, e.g. "getJobStats:ok"
 * @param {object} [payload] plain JSON-serializable fields only
 */
export function jobsUiDebugLog(section, payload) {
  if (!isJobsUiDebugEnabled()) {
    return
  }
  const ts = new Date().toISOString()
  if (payload && typeof payload === "object") {
    console.info("[CB jobs]", section, Object.assign({ ts: ts, section: section }, payload))
  } else if (payload !== undefined) {
    console.info("[CB jobs]", section, { ts: ts, section: section, data: payload })
  } else {
    console.info("[CB jobs]", section, { ts: ts, section: section })
  }
}
